// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cardContainerMultiColumnStyles } from "@insite/content-library/Components/CardContainerMultiColumn";
import { color, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

cardContainerMultiColumnStyles.gridItem = {
    width: [12, 6, 6, 4, 4],
    css: css`
        position: relative;
        padding-block: 24px;
        &::after {
            content: "";
            width: 100%;
            border-bottom: 1px solid ${color("common.border")};
            position: absolute;
            bottom: 0;
        }

        ${xScreen("lte", 700)} {
            flex-basis: 100%;
            max-width: 100%;
        }
    `,
};

cardContainerMultiColumnStyles.cardDivider = {
    css: css`
        height: 100%;
        width: 100%;
        overflow: hidden;
    `,
};
